// extracted by mini-css-extract-plugin
module.exports = {"container":"GA","disabled":"HA","remove":"IA"};